module.exports = __webpack_public_path__ + "static/media/flop.bb3269ae.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/flop.JPG
// module id = 257
// module chunks = 0